import {useState} from "react";

import Button  from "@mui/material/Button";
import Menu  from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import List from "@mui/material/List";

import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from '@mui/material/ListItemButton';
import Collapse  from "@mui/material/Collapse";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Divider from '@mui/material/Divider';


import {    Link as RouterLink,
    
  } from "react-router-dom"
  

const SimpleMenu = ({menu, handleCloseSideBar})=>{
    return (
        <>
        {
            (menu.divider) && <Divider/>
        }
        {
            (!menu.divider) &&
            <MenuItem  
                sx={{display:{lg:'block', md:`${menu.large?'none':'block'}`}}}
                component={RouterLink} 
                        to={menu.path? menu.path:'/'} 
                        onClick={handleCloseSideBar}>
                    <ListItemText>{menu.name}</ListItemText>
            </MenuItem>
        }
        </>
    )
}

const CollapseMenu = ({menu, handleCloseSideBar})=>{

    const [open, setOpen] = useState(true)
    
      
      const handleToggleCollapse = () => {
        setOpen(!open);
      };
    

    return (

        <>
            <ListItemButton sx={{minWidth:280}} onClick={handleToggleCollapse}
            
            >
                <ListItemText primary={menu.name} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}

            </ListItemButton>
            
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ pl: 4 }}>
                {
                    menu.sub.filter(x=>!x.divider).
                    
                    map((m, i)=>
                            <ListItemButton onClick={handleCloseSideBar} key={m.id} 
                            
                            component={RouterLink} 
                            to={m.path? m.path:'/'} >
                                <ListItemText primary={m.name}></ListItemText>
                            </ListItemButton>

                           

                        
                    )
                    
                }
                </List>
            </Collapse>

        
        </>
    )

}

const SideBarMenu = ({menu, handleCloseSideBar})=>{
    
    let content = Boolean(menu) && !menu.large ? 
    (   
        (menu.sub && menu.sub.length>0)  ? 
                <CollapseMenu menu={menu} handleCloseSideBar={handleCloseSideBar}/>: 
                  <SimpleMenu menu={menu} handleCloseSideBar={handleCloseSideBar}/>

    ) :null;
    return  content

}

export default SideBarMenu;